// Guard changes to an overflow menu's open state, preventing closing when focus is inside any nested dialog.
// see https://github.com/github/primer/issues/5896#issuecomment-3335244847
export function guardOverflowMenuChange(
  next: boolean,
  setOpen: (open: boolean | undefined) => void,
  {container = document.body}: {container?: ParentNode} = {},
) {
  if (!next) {
    const openDialogs = Array.from(container.querySelectorAll<HTMLElement>('[role="dialog"], dialog[open]'))
    const focusedDialog = openDialogs.find(d => d.contains(document.activeElement))
    if (focusedDialog) return
  }
  setOpen(next)
}

export type GuardOverflowMenuChange = typeof guardOverflowMenuChange
